import { createSelector } from 'reselect'

import * as gameSelectors from '../../game.selectors'
import * as preloaderSelectors from '../../../Preloader/preloader.selectors'

export const getCurrentSceneBackgrounds = createSelector(
  [gameSelectors.getCurrentScene, gameSelectors.getStoryLine, preloaderSelectors.getPreloader],
  (currentScene, storyLine, preloader) =>
    (currentScene.backgrounds || [])
      .filter((backgroundId) => !!storyLine.backgrounds[backgroundId])
      .map((backgroundId) => {
        const storyLineBackground = {
          ...storyLine.backgrounds[backgroundId],
          url: preloader.preloaded[backgroundId],
        }
        let sceneBackground = currentScene.backgrounds[backgroundId] || {}
        return { ...storyLineBackground, ...sceneBackground }
      })
)
